export default function useStoredImage() {
  function getImageFromFolder(folderName: string, fileName: string) {
    const storageFolderPath = `${process.env.REACT_APP_STORAGE_URI}/${folderName}/`;

    return storageFolderPath + fileName;
  }

  function getHighlightImageSrc(fileName: string): string {
    return getImageFromFolder("highlights", fileName);
  }

  function getBackgroundImageSrc(fileName: string): string {
    return getImageFromFolder("stories_backgrounds", fileName);
  }

  function getCommonImageSrc(fileName: string): string {
    return getImageFromFolder("common", fileName);
  }

  return {
    getHighlightImageSrc,
    getBackgroundImageSrc,
    getCommonImageSrc,
  };
}
